import textsData from '@/textData/DashboardTexts.json';
import { useDashboardFilter } from '@/contexts/DashboardFilterContext';
import { useUserLanguage } from './useUserLanguage';

/**
 * Leyenda de período (año / año+mes) para cards del dashboard cuando el filtro temporal está activo.
 * `null` si no hay año en el filtro.
 */
export function useDashboardCardPeriodCaption(): string | null {
  const { periodYear, periodMonth } = useDashboardFilter();
  const userLanguage = useUserLanguage();
  const texts =
    userLanguage === 'es' ? textsData.es.dashboardFilter : textsData.en.dashboardFilter;

  if (periodYear == null) return null;

  const locale = userLanguage === 'es' ? 'es' : 'en-US';
  let periodPhrase: string;

  if (periodMonth != null && periodMonth >= 1 && periodMonth <= 12) {
    const rawMonth = new Intl.DateTimeFormat(locale, { month: 'long' }).format(
      new Date(periodYear, periodMonth - 1, 1),
    );
    const monthName = rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1);
    periodPhrase = texts.periodSummaryMonthYear
      .replace('{{month}}', monthName)
      .replace('{{year}}', String(periodYear));
  } else {
    periodPhrase = texts.periodSummaryYear.replace('{{year}}', String(periodYear));
  }

  return texts.cardDataPeriod.replace('{{period}}', periodPhrase);
}
